import * as variables from './variables.js';

import './polyfill/matches';
import './polyfill/closest';
require('./polyfill/CustomEvent.js');

import { Analytics } from '@plaudit/analytics';
Analytics.getInstance();

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import './component/menu.service';

import Forms from './component/Forms';
Forms.init();

// @ts-ignore
var GeneralMap = require('./component/GeneralMap.js');
GeneralMap.init('.footerMap', '.addressFormat--US');

// @ts-ignore
require('./component/GeneralLightbox.js').init();

import './component/fontLoader';
import TabbedContent from './component/TabbedContent';
const contentCarousel = new TabbedContent({
	className: 'contentCarousel',
	doHeightChange: true,
});

import SmoothScroll from './lib/SmoothScroll';
const mySmoothScroll = new SmoothScroll();

mySmoothScroll.add('a[href*="#"]');
